import { getMultiplierOverrides } from '../infrastructure/repositories/exerciseConfigRepository';
import { applyMultiplierOverrides } from '../domain/scoring/exerciseCatalog';

/**
 * Pulls the admin's multiplier overrides into the exercise catalog.
 *
 * Started at boot without blocking first paint - an offline PWA must render
 * whether or not this resolves - but anything that *scores* a lift awaits
 * `overridesReady` first, so a lift can never be logged against a stale
 * multiplier just because the fetch was still in flight.
 *
 * Failure is deliberately swallowed: the catalog keeps its shipped multipliers,
 * which are correct, just not retuned. Refusing to score would be worse.
 */
let ready: Promise<void> = Promise.resolve();

export function loadExerciseOverrides(): Promise<void> {
  ready = getMultiplierOverrides()
    .then(applyMultiplierOverrides)
    .catch((err) => {
      console.error('Could not load exercise multiplier overrides:', err);
    });
  return ready;
}

/** Resolves once the overrides have been applied (or have failed to load). */
export function overridesReady(): Promise<void> {
  return ready;
}
